// resources/js/router/routes/tenants.js
export default [
  {
    path: '/tenants',
    name: 'tenants.index',
    component: () => import('@/views/tenants/TenantsIndex.vue'),
    meta: {
      requiresAuth: true,
      requiredRole: 'super_admin',
      title: 'sidebar.databaseManagement'
    }
  },
  {
    path: '/tenants/add',
    name: 'tenants.add',
    component: () => import('@/views/tenants/TenantAdd.vue'),
    meta: {
      requiresAuth: true,
      requiredRole: 'super_admin',
      title: 'tenants.add.title'
    }
  },
  {
    path: '/tenants/:id',
    name: 'tenants.view',
    component: () => import('@/views/tenants/TenantView.vue'),
    meta: {
      requiresAuth: true,
      requiredRole: 'super_admin',
      title: 'tenants.view.title'
    }
  },
  {
    path: '/tenants/:id/edit',
    name: 'tenants.edit',
    component: () => import('@/views/tenants/TenantEdit.vue'),
    meta: {
      requiresAuth: true,
      requiredRole: 'super_admin',
      title: 'tenants.edit.title'
    }
  }
];